<svg width="21" height="32" viewBox="0 0 21 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3.89404" y="11.1531" width="2.23698" height="17.8959" fill="#BBDAF3"/>
<path d="M10.605 2.95087L3.89404 11.1513H6.13462L12.842 2.95087H10.605Z" fill="#D8ECFE"/>
<path d="M6.13232 11.1531V29.049L12.8422 20.8467V2.95087L6.13232 11.1531Z" fill="#E6F2FE"/>
<path d="M15.0791 2.95087L8.36816 11.1513H10.6087L17.3161 2.95087H15.0791Z" fill="#D8ECFE"/>
<path d="M12.8413 18.0207L6.13037 26.2212H8.37094L15.0783 18.0207H12.8413Z" fill="#AAAAAA"/>
<rect x="6.13037" y="26.2211" width="2.23698" height="2.82784" fill="#888888"/>
<rect x="8.36816" y="11.1531" width="2.23698" height="17.8959" fill="#BBDAF3"/>
<path d="M10.6055 11.1531V29.049L17.3153 20.8467V2.95087L10.6055 11.1531Z" fill="#E6F2FE"/>
<path d="M3.89404 11.1512V29.049H10.605L17.3137 20.8467V2.95087H15.079L12.842 5.704V2.95087H10.605L3.89404 11.1512Z" stroke="black" stroke-width="1.5"/>
<path d="M3.89404 11.1532H6.13103" stroke="black" stroke-width="0.75"/>
<path d="M6.12842 26.2212H8.3654" stroke="black" stroke-width="0.75"/>
<path d="M8.36523 11.1532H10.6022" stroke="black" stroke-width="0.75"/>
<path d="M6.13037 29.0491V11.1531L12.8413 2.95087" stroke="black" stroke-width="0.75"/>
<path d="M10.6025 29.0491V11.1531L17.3135 2.95087" stroke="black" stroke-width="0.75"/>
<path d="M8.36523 29.0491V11.1531L15.0762 2.95087" stroke="black" stroke-width="0.75"/>
<path d="M6.15039 26.2566L8.37026 23.4987" stroke="black" stroke-width="0.75"/>
</svg>
